// extracted by mini-css-extract-plugin
export default {"wrapper":"directory-card_wrapper__hOl57","icon":"directory-card_icon__vt28X","text":"directory-card_text__hxlme"};